
import Vue from 'vue';

import { useCounterStore } from '../../stores/counter';
import { mapStores } from 'pinia';

export default Vue.extend({
    name: 'HomePage',
    props: {
        msg: String,
    },
    data() {
        return {
            a: 10, b: 20
        }
    },
    computed: {
        ...mapStores(useCounterStore)
    },
    mounted() {
        // console.log(this.a)
    },

});
